import { Angulartics2 } from '@angularticsCompat';
import { useContext } from 'react';
import { AppConfig } from '../core/app.config';
import { AuthService } from '../auth/services/auth.service';
import { ColorModeService } from '../core/services/color-mode.service';
import { DocLinkHandlerService } from '../docs/services/doc-link-handler.service';
import { GlobalConfigService } from '../core/services/global-config.service';
import { RbacService } from '../access-control/services/rbac.service';
import { ReactRouterService } from '../core/services/react-router.service';
import { RxRequestService } from '../core/services/rx-request.service';
import { SettingsStorageService } from '../auth/services/settings-storage.service';
import { UserService } from '../core/services/user.service';
import { KeyboardShortcuts } from '../a11y/shortcuts/service/keyboard-shortcuts.service';
import useService from '../injector/hooks/useService';
import { CoordinatedHeightAnchorContext } from '../layout/components/coordinated-height/HdCoordinatedHeight';
import { CoordinatedScrollAnchorContext, CoordinatedScrollContext } from '../a11y/scroll/components/coordinated-scroll/HdCoordinatedScroll';
import { ToasterService } from '../toaster/services/toaster.service';

export function useProvidersForAngular() {
  const authService = useService(AuthService);
  const userService = useService(UserService);
  const angulartics = useService(Angulartics2);
  const globalConfigService = useService(GlobalConfigService);
  const rxRequestService = useService(RxRequestService);
  const colorModeService = useService(ColorModeService);
  const docLinkHandlerService = useService(DocLinkHandlerService);
  const reactRouterService = useService(ReactRouterService);
  const settingsStorageService = useService(SettingsStorageService);
  const toasterService = useService(ToasterService);
  const keyboardShortcuts = useService(KeyboardShortcuts);
  const appConfig = useService(AppConfig);
  const rbacService = useService(RbacService);

  const reactCoordinatedHeightAnchorContext = useContext(CoordinatedHeightAnchorContext);
  const reactScrollAnchor = useContext(CoordinatedScrollAnchorContext)?.anchorEl;
  const reactCoordinatedScrollParent = useContext(CoordinatedScrollContext)?.el;

  return {
    'RBAC_SERVICE': rbacService,
    'APP_CONFIG': appConfig,
    'AUTH_SERVICE': authService,
    'USER_SERVICE': userService,
    'ANGULARTICS': angulartics,
    'GLOBAL_CONFIG_SERVICE': globalConfigService,
    'RX_REQUEST_SERVICE': rxRequestService,
    'COLOR_MODE_SERVICE': colorModeService,
    'DOC_LINK_HANDLER_SERVICE': docLinkHandlerService,
    'REACT_ROUTER_SERVICE': reactRouterService,
    'SETTINGS_STORAGE_SERVICE': settingsStorageService,
    'TOASTER_SERVICE': toasterService,
    'KEYBOARD_SHORTCUTS': keyboardShortcuts,
    'COORDINATED_HEIGHT_ANCHOR': !!reactCoordinatedHeightAnchorContext
      ? {
        el: {
          nativeElement: reactCoordinatedHeightAnchorContext.anchorEl
        },
        getAnchorHeight: () => {
          const anchorEl = reactCoordinatedHeightAnchorContext.anchorEl;

          return anchorEl.clientHeight - reactCoordinatedHeightAnchorContext.heightOffset;
        }
      }
      : undefined,
    'COORDINATED_SCROLL_ANCHOR': !!reactScrollAnchor
      ? {
        getTopOffset: () => reactScrollAnchor.offsetTop
      }
      : undefined,
    'COORDINATED_SCROLL': !!reactCoordinatedScrollParent
      ? {
        _scrollViewport: {
          measureScrollOffset: () => {
            return reactCoordinatedScrollParent.scrollTop;
          }
        },
        scrollToAnchor: top => {
          reactCoordinatedScrollParent.scrollTo({ top, behavior: 'smooth' });
        }
      }
      : undefined
  };
}
